import { RestaurantActionTypes } from './restaurant.types';

const initialState: WebOrder.State.Restaurant = {
  loyaltyCampaigns: undefined,
};

export const restaurantReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: WebOrder.State.Restaurant = initialState,
  action: RestaurantActionTypes,
): WebOrder.State.Restaurant => {
  switch (action.type) {
    case 'SET_CAMPAIGN_PROGRESS': {
      const campaignProgressData =
        action.payload.status === 'success' ? action.payload.data : [];

      return {
        ...state,
        loyaltyCampaigns: {
          ...state.loyaltyCampaigns,
          [action.payload.prId]: {
            data: campaignProgressData,
            status: action.payload.status,
          },
        },
      };
    }

    default:
      return state;
  }
};
